import { z } from "zod";

export const wishSubmissionSchema = z.object({
  name: z.string().trim().min(1).max(120),
  message: z.string().trim().min(1).max(500)
});

export type WishSubmission = z.infer<typeof wishSubmissionSchema>;
